class ConfiguratorIntersectionalObserver extends HTMLElement {
  #observer
  #url
  #filter
  #grid
  #parser
  #templateSelector
  #cache = {}
  #ids = new Set();

  constructor() {
    super();
    this.#parser = new DOMParser();
    this.#grid = this.querySelector('.configurator-grid__items__grid');
  }

  connectedCallback() {
    this.#observer = new IntersectionObserver((e) => this.#onIntersection(e), { threshhold: 1.0 });
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    if (this.#observer) this.#observer.disconnect();
  }

  static get observedAttributes() {
    return ['data-filter', 'data-url', 'data-template-type'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-filter' && newValue !== '') {
      if (this.#observer) this.#observer.unobserve(this);
      this.#filter = newValue;
      //
      if (!this.#cache[this.#filter]) {
        this.#cache[this.#filter] = {
          curPage: 1,
          count: 0,
          loaded: false,
          order: []
        }
      }
      //
      this.#grid.childNodes.forEach(el => {
        el.dataset.show = el.dataset.tags.split(',').includes(this.#filter);
      });
      /* this.#sort(); */
      if (this.#observer) this.#observer.observe(this);
    }
    //
    if (name === 'data-url' && newValue !== '') {
      this.#url = newValue;
    }
    //
    if (name === 'data-template-type' && newValue !== '') {
      this.#templateSelector = `[data-${newValue}-template]`;
    }
  }

  #onIntersection(entries) {
    entries.forEach((entry) => {
      /* console.log(entry.isIntersecting, entry.time); */
      if (entry.isIntersecting) {
        this.#observer.unobserve(this);
        this.#fetchNextPage();
      }
    });
  }

  #sort() {
    const items = Array.from(this.#grid.childNodes).filter(el => el.dataset.show === 'true')
    .sort((a,b) => this.#cache[this.#filter].order.indexOf(a.dataset.productId) - this.#cache[this.#filter].order.indexOf(b.dataset.productId));
    if (items && items.length) this.#grid.append(...items);
  }

  async #fetchNextPage() {
    if (!this.#cache[this.#filter].loaded) {
      const resp = await fetch(`${this.#url}/${this.#filter}?page=${this.#cache[this.#filter].curPage}`, {
        'Content-Type': 'text/html; charset=utf-8'
      });

      if (resp.ok) {
        const html = await resp.text();
        const doc = this.#parser.parseFromString(html, 'text/html');
        const items = Array.from(doc.querySelectorAll(this.#templateSelector))
                    .map(template => {
                      const div = document.createElement('DIV');
                      div.innerHTML = template.innerHTML;
                      return div.firstElementChild;
                    });
        /* console.log(items.length); */
        if (items.length) {
          const filteredItems = items.filter(el => !this.#ids.has(el.dataset.productId));
          filteredItems.forEach(el => {
            this.#ids.add(el.dataset.productId);
            el.dataset.show = 'true';
          });
          this.#grid.append(...filteredItems);
          this.#cache[this.#filter].curPage += 1;
          this.#cache[this.#filter].count += items.length;
          this.#cache[this.#filter].order = [...this.#cache[this.#filter].order, ...items.map(el => el.dataset.productId)];
          this.#sort();
          this.#dispatchEvent('itemsadded', this.#cache[this.#filter].count);
          this.#observer.observe(this);
        } else {
          this.#cache[this.#filter].loaded = true;
          this.#dispatchEvent('itemsloaded', this.#cache[this.#filter].count);
        }
      }
    } else {
      this.#sort();
    }
  }

  #dispatchEvent(eventname, count) {
    const event = new CustomEvent(eventname, { detail: { count } });
    this.dispatchEvent(event);
  }
    
}

customElements.define('configurator-intersectional-observer', ConfiguratorIntersectionalObserver);